function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1 9.56763V31.8057C1 31.8057 1.23384 53.5775 26.965 61.0294C26.965 61.0294 49.7709 56.8379 52.4615 32.504V9.56763L26.7304 2L1 9.56763Z",
  fill: "#1E88E5",
  stroke: "white",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19.5 44V42.5H33V44H19.5ZM33.5273 32.5273L26.25 39.8633L18.9727 32.5273L20.0273 31.4727L25.5 36.9805V20H27V36.9805L32.4727 31.4727L33.5273 32.5273Z",
  fill: "white"
});

var SvgDownloadMyData = function SvgDownloadMyData(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 63,
    viewBox: "0 0 54 63",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDownloadMyData, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Download-My-Data.2019956d.svg";
export { ForwardRef as ReactComponent };